import React from 'react';
import { ASPECT_RATIOS } from './controlConstants.js';

export function AspectRatioSelector({ currentRatio, onSelectRatio }) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8' }}>
          Relación de Aspecto
        </label>
        <span style={{ fontSize: '11px', color: '#c084fc', fontWeight: 600 }}>
          {ASPECT_RATIOS.find(r => r.id === currentRatio)?.tag}
        </span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
        {ASPECT_RATIOS.map((ratio) => {
          const isSelected = currentRatio === ratio.id;
          return (
            <button
              key={ratio.id}
              type="button"
              onClick={() => onSelectRatio(ratio.id)}
              title={ratio.tag}
              style={{
                padding: '10px 4px',
                borderRadius: '8px',
                fontSize: '11px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                background: isSelected ? 'rgba(168, 85, 247, 0.16)' : '#141724',
                color: isSelected ? '#c084fc' : '#94a3b8',
                border: isSelected ? '1px solid rgba(192, 132, 252, 0.6)' : '1px solid rgba(255,255,255,0.06)',
                boxShadow: isSelected ? '0 0 12px rgba(168, 85, 247, 0.25)' : 'none',
                transition: 'all 0.15s ease'
              }}
            >
              {/* Wireframe en miniatura del encuadre */}
              <div
                style={{
                  width: `${ratio.width}px`,
                  height: `${ratio.height}px`,
                  border: isSelected ? '1.5px solid #c084fc' : '1.5px solid #64748b',
                  borderRadius: '2px',
                  background: isSelected ? 'rgba(192, 132, 252, 0.2)' : 'transparent',
                  transition: 'all 0.15s ease'
                }}
              />
              <span>{ratio.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

